import React from 'react';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export const LanguageToggle = ({ language, onLanguageChange }) => {
  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-slate-400" />
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onLanguageChange(language === 'fr' ? 'en' : 'fr')}
        className="text-sm font-medium hover:text-[#D4AF37] transition-colors"
      >
        {language === 'fr' ? 'EN' : 'FR'}
      </Button>
    </div>
  );
};
